/**
 * @fileoverview Utility function for formatting currency values in GBP.
 *
 * CANONICAL COPY. Extracted from backend/src/utils/currencyFormatter.js, which was
 * itself duplicated in frontend/src/utils/currencyFormatter.js. The till frontend
 * keeps its own copy because Create React App refuses imports from outside src/;
 * that copy is functionally identical and should be kept in step by hand.
 *
 * This function:
 *  - Forces very small values (e.g., below a dynamically determined threshold based on decimal places) to 0.
 *  - Ensures negative values display as `-£12.4567` rather than `£-12.4567`.
 *  - Allows formatting up to four decimal places, defaulting to two.
 */

/**
 * Formats a numeric value as a GBP currency string.
 *
 * @param {number} value - The numeric value to be formatted.
 * @param {number} [decimalPlaces=2] - The number of decimal places (up to 4).
 * @returns {string} - The formatted currency string, prefixed with `£`.
 */
function formatCurrency(value, decimalPlaces = 2) {
    value = Number(value);
    decimalPlaces = Math.min(Math.max(decimalPlaces, 2), 4);

    const threshold = 10 ** -decimalPlaces / 2;
    if (Math.abs(value) < threshold) {
        value = 0;
    }

    const absValue = Math.abs(value).toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: decimalPlaces
    });
    return value < 0 ? `-£${absValue}` : `£${absValue}`;
}

module.exports = { formatCurrency };
